/**
 * Момент времени человеку.
 *
 * Служба отдаёт время машинным видом (`2026-08-10T12:34:56.390Z`) — так его
 * и следует передавать между системами. Но на экране это заставляет читать
 * дату по буквам, а часовой пояс держать в уме: `Z` — не то время, в
 * котором живёт читающий.
 *
 * Формат берётся у браузера: у него и есть верное представление о поясе и
 * о том, как принято писать дату у читающего.
 */
const FORMAT = new Intl.DateTimeFormat('ru-RU', {
  dateStyle: 'short',
  timeStyle: 'short',
})

export function formatMoment(iso: string): string {
  const at = new Date(iso)
  // Непонятное значение показывается как есть: подменять его прочерком
  // значит скрывать, что служба прислала что-то неожиданное.
  if (Number.isNaN(at.getTime())) return iso
  return FORMAT.format(at)
}
